import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "MR_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#MR_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#1C7B4D"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "MR_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#MR_svg__b)", fillRule: "evenodd", clipRule: "evenodd" }, /* @__PURE__ */ e.createElement("path", { d: "M0 0v6h32V0H0zM0 18v6h32v-6H0z", fill: "#E31D1C" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M16.241 14.378c5.186.029 6.646-4.313 6.646-4.313-.294 3.715-2.348 6.234-6.646 6.234-4.297 0-5.875-3.263-6.645-6.519 0 0 1.46 4.57 6.645 4.598z",
      fill: "#FECA00"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M17.637 9.814l.337 1.963-1.764-.927-1.763.927.337-1.963-1.427-1.534h1.972l.881-1.93.882 1.93h1.972l-1.427 1.534z",
      fill: "#FECA00"
    }
  )))
), a = t;
export {
  a as default
};
